// extracted by mini-css-extract-plugin
export default {"starRating":"StarRating_starRating__iKqgw","label":"StarRating_label__6IA0P"};